require("babel-polyfill");
import superagent, { agent } from 'superagent';

const API = {};

API.getSuggester = async (suggest, suggester, callback) => {
  return new Promise((resolve, reject) => {
    superagent
      .get(`${process.env.REACT_APP_SUGGEST_API}?q=${suggest}&size=15&suggester=${suggester}&fuzzy=true`)
      .set('X-Api-Key', process.env.REACT_APP_SEARCH_API_KEY)
      .end((err, res) => {
        if (!err) {
          const response = JSON.parse(res.text);
          if (callback) {
              callback(response);
          } else {
              resolve(response);
          }
        } else {
            console.log('err', err);
            reject(err);
        }
      });
  });
}


API.getSuggestedProperties = async (suggest, callback) => {
  let suggester = '';
  // API.getSuggester(suggest, 'state_suggester', (response) => {
  //     if (response['suggest']['found'] > 0) {
  //         suggester = 'state';
  //         callback(response, suggester);
  //     } else {
          API.getSuggester(suggest, 'city_state_suggester', (res) => {
              if (res['suggest']['found'] > 0) {
                  suggester = 'city_state';
                  callback(res, suggester);
              } else {
                  API.getSuggester(suggest, 'zipcode_suggester', (data) => {
                      if (data['suggest']['found'] > 0) {
                          suggester = 'zipcode';
                          callback(data, suggester);
                      }
                      else {
                        API.getSuggester(suggest, 'city_suggester', (data) => {
                          if (data['suggest']['found'] > 0) {
                              suggester = 'city';
                              callback(data, suggester);
                          }
                        });
                        //  API.getSuggester(suggest, 'address_suggester', (data) => {
                        //      if (data['suggest']['found'] > 0) {
                        //          suggester = 'address';
                        //          callback(data, suggester);
                        //      } else {
                        //           API.getSuggester(suggest, 'name_suggester', (data) => {
                        //               if (data['suggest']['found'] > 0) {
                        //                   suggester = 'name';
                        //                   callback(data, suggester);
                        //               } else {
                        //                   callback([], 'country');
                        //               }
                        //           });
                        //      }
                        //   });
                      }
                  });
              }
          });
      // }
  // });
};


API.searchPropertyByBusinessName = async (nameOfBusiness, addressOfBusiness, suggestion, suggester, industryTypes, callback) => {
  console.log('SEARCH__TYPE Name search business called', nameOfBusiness);

  const size = process.env.REACT_MAP_TOTAL_BUSINESSES;
  let category = '';
  industryTypes.map(industry => {
    industry = encodeURIComponent(industry);
    category += ` category:'${industry}'`
  });

  let parser = 'structured';
  let suggestedValue = '';
  let searchedValue = encodeURIComponent(suggestion);

  (suggester == 'city') && (suggestedValue += ` location_address_city:'${searchedValue}'`);
  (suggester == 'state') && (suggestedValue += ` location_address_state:'${searchedValue}'`);
  (suggester == 'zipcode') && (suggestedValue += ` zip_code:'${searchedValue}'`);
  const businessNameValue = encodeURIComponent(nameOfBusiness).replace(/'/g, '');
  // const address = `location_address:'${addressOfBusiness.replace(/'/g,'').match(/\b(\w+)\b/g)}'`
  const address = `location_address:'${encodeURIComponent(addressOfBusiness).replace(/'/g, '')}'`;

  var returnValues = 'business_name,location_address,zip_code,location_address_city,latitude,longitude,category,valuation,full_address';
  // let returnValues = 'business_name,location_address,location_address_city,location_address_state,location_address_city_state,county,zip_code,latitude,longitude,latlong,category,valuation,full_address';

  superagent
    .get(`${process.env.REACT_APP_SEARCH_API}?q.parser=${parser}&size=${size}&fq=(and ${suggestedValue} (and ${address}))&q=(and+(term+field%3Dbusiness_name+'${businessNameValue}'))&return=${returnValues}`)
    .set('X-Api-Key', process.env.REACT_APP_SEARCH_API_KEY)
    .end((err, res) => {
      if (!err) {
        const response = JSON.parse(res.text);
        callback(response);
      } else {
        console.log('err', err);
      }
    });
}


API.searchSuggester = async (businessName, suggestion, suggester, industryTypes, callback) => {
  console.log('SEARCH__TYPE Category search called');

  let category_filters = industryTypes.map(industry => `category:'${industry}'`).join(' ');

  const searchWords = businessName.replace(/'/g,'').match(/\b(\w+)\b/g);
  let search_filter = searchWords.map(w => `(prefix field=business_name '${w}')`).join('')

  let query = {
      'q.parser': 'structured',
      'size': 15,
      'q': `(or ${search_filter})`,
      'return': 'business_name,category,location_address'
  };
  if (suggestion) {
      const suggester_fields = {
          'city': 'location_address_city',
          'state': 'location_address_state',
          'zipcode': 'zip_code',
          'city_state': 'location_address_city_state'
      }
      let suggester_filter = `${suggester_fields[suggester]}:'${suggestion}'`;
      query['fq'] = `(and ${suggester_filter} (or ${category_filters}))`;
  } else {
      query['fq'] = `(or ${category_filters})`;
  }

  superagent
      .get(`${process.env.REACT_APP_SEARCH_API}`)
      .query(query)
      .set('X-Api-Key', process.env.REACT_APP_SEARCH_API_KEY)
      .end((err, res) => {
          if (!err) {
              const response = JSON.parse(res.text);
              callback(response);
          } else {
              console.log('err', err);
          }
      });
}


API.searchPropertyByCategory = async (suggestion, suggester, industryTypes, callback) => {
  console.log('SEARCH__TYPE Category search called', suggestion, suggester, industryTypes);

    const mapping = {
        'city': 'location_address_city_state',
        'state': 'location_address_state',
        'zipcode': 'zip_code',
        'name': 'business_name',
    }
    const size = 1;
    let category = '';
    industryTypes.map(industry => {
        industry = encodeURIComponent(industry);
        category += ` category:'${industry}'`
    });
    const industryType = encodeURIComponent(category);
    const field = mapping[suggester];
    const suggestionValue = suggestion.replace(/'/g,'').match(/\b(\w+)\b/g);
    let parser = 'structured';

    var returnValues = 'business_name,location_address,zip_code,location_address_city,latitude,longitude,category,valuation,full_address';
    // let returnValues = 'business_name,location_address,location_address_city,location_address_state,location_address_city_state,county,zip_code,latitude,longitude,latlong,category,valuation,full_address';

  superagent
    // .get(`${process.env.REACT_APP_SEARCH_API}?q.parser=${parser}&size=${size}&q=(and+(term+field%3D${field}+'${suggestionValue}'))&return=${returnValues}`)
    .get(`${process.env.REACT_APP_SEARCH_API}`)
    .query({
      'q.parser': 'structured',
      'q': `(and (term field=${field} '${suggestionValue}'))`,
      'size': size,
      'return': returnValues
    })
    .set('X-Api-Key', process.env.REACT_APP_SEARCH_API_KEY)
    .end((err, res) => {
      if (!err) {
        const response = JSON.parse(res.text);
        callback(response);
      } else {
        callback(err);
        console.log('err', err);
      }
    });
}


API.searchByBoundingBox = async (geoFields, upperLeft, lowerRight, industryTypes, callback) => {

  let latlong = geoFields['latlong'];
  console.log('SEARCH__TYPE bounding box called');
  let category = '';
  industryTypes.map(industry => {
    industry = encodeURIComponent(industry);
    category += ` category:'${industry}'`
  });
  window.superagent = superagent;

  let returnValues = 'business_name,location_address,zip_code,location_address_city,latitude,longitude,category,valuation,full_address';
  // let returnValues = 'business_name,location_address,location_address_city,location_address_state,location_address_city_state,county,zip_code,latitude,longitude,latlong,category,valuation,full_address';

  superagent
    .get(`${process.env.REACT_APP_SEARCH_API}`)
    .query({
      'q.parser': 'structured',
      'q': 'matchall',
      'fq': `(and latlong:['${upperLeft}','${lowerRight}'])`,
      'expr.geo': '_rand',
      // 'expr.geo': `haversin(${latlong},latlong.latitude,latlong.longitude)`,
      'sort': 'geo asc',
      'size': 100,
      'return': returnValues
    })
    .set('X-Api-Key', process.env.REACT_APP_SEARCH_API_KEY)
    .end((err, res) => {
      if (!err) {
        const response = JSON.parse(res.text);
        callback(response);
      } else {
        console.log('err', err);
      }
    });
}

export default API;
